import { RouterProvider } from 'react-router-dom';
import router from './router';
import ReactGA from 'react-ga4';
import { GOOGLE_ANALYTICS_ID } from './constants';

import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

function App() {
  // Initialize Google Analytics
  if (GOOGLE_ANALYTICS_ID) {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID);
  }

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
